import { createTheme, MantineThemeProvider, mergeMantineTheme, useMantineTheme } from '@mantine/core';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { useAdminSignOut } from '@admin/hooks';
import { USER_LAYOUT_PER_SECOND } from '@constants';
import classes from '@features/layout/UserLayout/UserLayout.module.css';
import { useSettings } from '@hooks/useSettings';
import { AdminHeader } from './AdminHeader';
import { AdminSidebar } from './AdminSidebar';

export const AdminUserLayout = () => {
  const { data: settings } = useSettings();
  const navigate = useNavigate();
  const navigationCallback = () => {
    navigate(`/${settings.adminPath}/auth`);
  };
  const signOutMutation = useAdminSignOut(navigationCallback);
  const baseTheme = useMantineTheme();

  // const myColor: MantineColorsTuple = ['#e2fbff', '#d1f2fb', '#a7e2f2', '#7ad1ea', '#55c3e2', '#3dbade', '#2bb6dd', '#16a0c5', '#008eb1', '#007c9c'];

  const customTheme = mergeMantineTheme(
    baseTheme,
    createTheme({
      // primaryColor: 'myColor',
      // colors: { myColor },
    }),
  );

  useEffect(() => {
    if (settings) {
      const timeout = setTimeout(() => {
        signOutMutation.mutate();
      }, USER_LAYOUT_PER_SECOND * settings.jwtExpirationTime);

      return () => clearTimeout(timeout);
    }
  }, [settings]);

  return (
    <MantineThemeProvider theme={customTheme}>
      <div className={classes.layoutContainer}>
        <AdminHeader />
        <div className={classes.container}>
          <AdminSidebar />
          <div className={classes.contentWrapper}>
            <div className={classes.content}>
              <div className={classes.contentBox}>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </MantineThemeProvider>
  );
};
